<template>
  <div class="PolymorphicPageMain">
    <PolymorphicHero v-if="content.hero" :content="content.hero" :breadcrumbs="breadcrumbs" />
    <PageNav v-if="pageNavEntries" :entries="pageNavEntries" :content="content.pageNav" />
    <AutoBodySection
      v-for="sectionContent in content.bodySections || []"
      :key="sectionContent._key"
      :content="sectionContent"
      :id="bodySectionId(sectionContent)"
      class="bodySection"
      :class="sectionHasSeparator(sectionContent) && 'sectionWithSeparator'"
    />
    <PromoPopup v-if="content.promoPopup" :content="content.promoPopup" />
    <FooterCta v-if="content.footerCta" :content="content.footerCta" />
  </div>
</template>

<script>
export const contentQueryFragment = `
  locale,
  brand,
  pencilBanner,
  hero,
  pageNav,
  bodySections,
  promoPopup,
  footerCta,
`
</script>

<script setup>
import toSlug from '~/lib/to-slug.js'

import AutoBodySection from './bodySections/AutoBodySection.vue'
import FooterCta from './headerFooterSections/FooterCta.vue'
import PageNav from './headerFooterSections/PageNav.vue'
import PolymorphicHero from './headerFooterSections/PolymorphicHero.vue'
import PromoPopup from './headerFooterSections/PromoPopup/index.vue'

function bodySectionId({ sectionId, navEntry }) {
  if (sectionId) {
    return sectionId
  }
  if (navEntry?.id) {
    return navEntry.id
  }
  if (navEntry?.title) {
    return toSlug(navEntry.title)
  }
}

function sectionHasSeparator({ presentationOptions }) {
  return presentationOptions?.hasSeparator || false
}

const { breadcrumbs, content } = defineProps({
  breadcrumbs: Array,
  content: Object,
})

const bodySectionsToShowInNav = (content.bodySections || []).filter(
  ({ navEntry }) => navEntry?.showInNav && navEntry.title
)

const pageNavEntries = (
  bodySectionsToShowInNav.length > 0
    ? bodySectionsToShowInNav.map(
        (sectionContent) => ({
          _key: sectionContent._key,
          title: sectionContent.navEntry.title,
          targetId: bodySectionId(sectionContent),
        })
      )
    : false
)
</script>

<style scoped>
.PolymorphicPageMain {
  --body-font-size: var(--font-size-3);
  --body-line-height: 1.7;
}
.sectionWithSeparator {
  border-top: thin solid var(--hairline-color);
}
.bodySection {
  scroll-margin-top: 4rem;  /* Ensure title isn't covered by sticky-nav */
}
</style>
